import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=89b8b04e&"
import script from "./BlockUI.vue?vue&type=script&lang=ts&"
export * from "./BlockUI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports